
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide",
      function () {
        return require("private-next-pages/guide.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guide"])
      });
    }
  